import { Card, Col, Divider, Radio, Row } from 'antd';
import React, { useState } from 'react';
import styles from './styles.module.css';
import { pricePackages } from './pricepackages';
import { useIntl } from 'react-intl';
import classnames from 'classnames';
import { addDays, formatISO } from 'date-fns';
import { Hike } from 'services/hitchit/types/hike/Hike';
import { HitchGoLive } from 'components/public/integrations/useHitchConfiguration';
import PricePackage from './PricePackage';

const PriceChoices = ({
  hike,
  hitchGoLive,
}: {
  hike: Hike;
  hitchGoLive: HitchGoLive;
}): JSX.Element => {
  const { formatMessage } = useIntl();

  const [currency, setCurrency] = useState<'euro' | 'dollar'>('euro');

  const packages = Object.entries(pricePackages).map(([key, { min, max }]) => {
    return (
      <Col key={key}>
        <Card
          bordered
          hoverable
          onClick={() => hitchGoLive.setSelectedBillingPackage(key)}
          className={classnames(
            key === hitchGoLive.selectedBillingPackage ? styles.selected : undefined
          )}
        >
          <p>{`${min}${max ? ` - ${max}` : `+`}`}</p>
        </Card>
      </Col>
    );
  });

  return (
    <>
      <p>
        {formatMessage({
          defaultMessage: 'Let us help you in picking the right package for you',
          description: '/onboarding/pricepackage/description/1',
        })}
      </p>
      <p>
        {formatMessage({
          defaultMessage:
            'The more sales you have, the more we work for you, and the cheaper it becomes per sale.',
          description: '/onboarding/pricepackage/description/2',
        })}
      </p>
      <Divider orientation="left">
        <h3>
          {formatMessage({
            defaultMessage: 'Last hurdle: Choose your package',
            description: '/onboarding/pricepackage/description/3',
          })}
        </h3>
      </Divider>
      <p>
        {formatMessage({
          defaultMessage: 'How many sales do you have per month?',
          description: '/onboarding/pricepackage/question',
        })}
      </p>
      <Row justify="space-around">{packages}</Row>
      <Divider />{' '}
      <p>
        {formatMessage({
          defaultMessage:
            'Based on your sales, and after your free trail, this is the package we propose:',
          description: '/onboarding/pricepackage/proposal',
        })}
      </p>
      <Row gutter={[32, 32]}>
        <Col>
          <PricePackage
            currency={currency}
            pricePackage={pricePackages[hitchGoLive.selectedBillingPackage] || {}}
          />
        </Col>
        <Col span={24}>
          <Radio.Group
            buttonStyle="solid"
            onChange={(a) => setCurrency(a.target.value)}
            value={currency}
          >
            <Radio.Button value="euro">Euro</Radio.Button>
            <Radio.Button value="dollar">Dollar</Radio.Button>
          </Radio.Group>
        </Col>
      </Row>
      <p>
        {formatMessage(
          {
            defaultMessage: 'Your trail period will end on {date}.',
            description: '/onboarding/pricepackage/proposal',
          },
          { date: formatISO(addDays(hike.createdAt, 14), { representation: 'date' }) }
        )}
      </p>
      <p>
        {formatMessage({
          defaultMessage: 'No worries, you can always change package afterwards.',
          description: '/onboarding/pricepackage/proposal',
        })}
      </p>
    </>
  );
};
export default PriceChoices;
